import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { FiEdit2, FiDroplet, FiSmile, FiTrash2, FiLogOut } from "react-icons/fi";
import TinyContextMenu from "../tiny-context-menu/TinyContextMenu";
import TitleEditPanel from "./TitleEditPanel";
import ConfirmTitleAction from "./ConfirmTitleAction";
import "./title-actions.scss";

export default function TitleActions({ kind, record, canEdit, canDelete, canLeave, onSave, onDelete, onLeave }) {
  const anchor = useRef(null);
  const menu = useRef(null);
  const [mode, setMode] = useState(null);
  const { pathname } = useLocation();
  const project = kind === "project";
  useEffect(() => { setMode(null); menu.current?.close(); }, [pathname]);
  const actions = [
    ...(canEdit ? [
      { key: "rename", label: "Rename", icon: <FiEdit2 />, onPress: () => setMode("rename") },
      { key: "appearance", label: project ? "Change icon" : "Change color", icon: project ? <FiSmile /> : <FiDroplet />, onPress: () => setMode("appearance") },
    ] : []),
    ...(canDelete ? [{ key: "delete", label: `Delete ${kind}`, icon: <FiTrash2 />, danger: true, onPress: () => setMode("delete") }] : []),
    ...(canLeave ? [{ key: "leave", label: "Leave workspace", icon: <FiLogOut />, onPress: () => setMode("leave") }] : []),
  ];
  return <div ref={anchor} className={`ant-title ant-title--${kind}${mode === "rename" || mode === "appearance" ? " ant-title--editing" : ""}`} onContextMenu={event => {
    if (!event.currentTarget.contains(event.target) || !actions.length) return;
    event.preventDefault(); event.stopPropagation(); menu.current?.openAt(event.clientX, event.clientY);
  }}>
    <span className="ant-title__icon" aria-hidden="true" style={{ background: project ? record.color || "transparent" : record.color || "#89afb4" }}>
      {project ? record.emojicon || "📋" : (record.name || "W").charAt(0)}
    </span>
    <span className="ant-title__text" title={record.name}>{record.name || `Untitled ${kind}`}</span>
    {!!actions.length && <TinyContextMenu ref={menu} items={actions} itemHeight={40} label={`${kind === "project" ? "Project" : "Workspace"} options`} />}
    {mode && !["delete", "leave"].includes(mode) && <TitleEditPanel anchorRef={anchor}
      kind={kind} record={record} startAt={mode} canEdit={canEdit} onSave={onSave} onClose={() => setMode(null)} />}
    {["delete", "leave"].includes(mode) && <ConfirmTitleAction anchorRef={anchor}
      label={mode === "leave" ? "Leave workspace" : `Delete ${kind}`}
      message={mode === "leave" ? `Leave “${record.name}”? You will lose workspace membership.` : `Delete “${record.name}”${project ? "" : " and its projects"}? This cannot be undone.`}
      allowed={mode === "leave" ? canLeave : canDelete}
      onConfirm={mode === "leave" ? onLeave : onDelete} onClose={() => setMode(null)} />}
  </div>;
}
